// path: frontend/src/components/SubstitutionBadge.jsx
/**
 * Индикатор активных замещений в карточке пользователя.
 *
 * user.substitutions приходит с GET /auth/me (SubstitutionDto[]).
 * Раньше собирались на клиенте через getSubstitutionInfo — удалено.
 *
 * Показывает строку «замещает X до даты» и повод в подсказке. Полный
 * список прав — в «Запросы и заявки».
 */
import { fmtDMY } from "../utils/date";
import { substitutionKindLabel } from "../utils/constants";

export function SubstitutionBadge({ user, empName }) {
  const subs = user?.substitutions ?? [];
  if (subs.length === 0) return null;

  return (
    <div className="user-substituting">
      {subs.map((s) => (
        <div key={s.id} title={s.reasonText || substitutionKindLabel(s.kind)}>
          замещает {empName(s.fromId)} до {fmtDMY(s.end)}
        </div>
      ))}
    </div>
  );
}
